import React from 'react';

export default function NavLinks({ className = '', onClick }: { className?: string, onClick?: () => void }) {
  return (
    <>
      <a href="/#features" className={`${className} hover:text-blue-600`} onClick={onClick}>Features</a>
      <a href="/#how-it-works" className={`${className} hover:text-blue-600`} onClick={onClick}>How it Works</a>
      <a href="/#pricing" className={`${className} hover:text-blue-600`} onClick={onClick}>Pricing</a>
    </>
  );
}